import { render, staticRenderFns } from "./tixian.vue?vue&type=template&id=54aa7790&scoped=true"
import script from "./tixian.vue?vue&type=script&lang=js"
export * from "./tixian.vue?vue&type=script&lang=js"
import style0 from "./tixian.vue?vue&type=style&index=0&id=54aa7790&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa7790",
  null
  
)

export default component.exports